
import Vue from "vue"
import { mapGetters } from "vuex"
import type { FullSession } from "@/types/api/program"

export default Vue.extend({
  async asyncData ({ route, redirect, app, $api }) {
    const goUp = () => redirect(app.localePath("/program"))

    const alias = route.params.alias
    if (!alias) return goUp()

    const [res, err] = await $api.program.getSession(alias)
    if (err || !res) return goUp()

    return { session: res }
  },

  data: () => ({
    session: null as Nullable<FullSession>,
  }),

  head () {
    return {
      title: this.getTitle(this.session?.title),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
